import React, { useRef } from "react";
import "../../../Compliance Management/Compliance Tabs/Compliance.css";
import AllChatbot from "../../../All_Chatbot/AllChatbot";

const Laws = () => {
  const floridaRef = useRef(null);
  const newYorkRef = useRef(null);
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  // Function to handle alphabet click
  const scrollToState = (letter) => {
    switch (letter) {
      case "F":
        floridaRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "N":
        newYorkRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <section className="tab-group compliance-tab-group">
        <div className="">
          <div className="inner-wrapper-box">
            <div className="upper-block justify-content-between">
              <div className="upper-left-block order-2 order-lg-1">
                <div className="d-flex align-items-center justify-content-between tabs-compliance-mngmnt "></div>
                <div className="tab-content-compliance">
                  <div className="gov-docs d-flex align-items-center justify-content-between">
                    {/* <div className="gov-title">State Laws and Regulations</div> */}
                    <div className="gov-title">Search Law Library</div>
                  </div>

                  <div className="alphabet-navigation d-flex flex-wrap my-3 px-3">
                    {alphabet.map((letter) => (
                      <button
                        key={letter}
                        onClick={() => scrollToState(letter)}
                        className={`${
                          letter === "F" || letter === "N"
                            ? // true
                              "btn-alpha"
                            : "btn-alpha-disabled"
                        }`}
                        disabled={letter !== "F" && letter !== "N"}
                      >
                        {letter}
                      </button>
                    ))}
                  </div>

                  <div className="analyze-box">
                    <div className="analyze-innerbox">
                      <div className="state-laws-box" ref={floridaRef}>
                        <h6 className="laws-title mt-2">
                          Florida's Chapter 718 Condominium Act
                        </h6>
                        <ol className="ps-0">
                          <li className="florida-act-list">
                            <div className="definition">
                              Definition of a Condominium
                            </div>
                            <div className="comp-summary mt-2 mb-2">
                              Statute: 718.103(11)
                            </div>
                            <ul className="laws-sublist">
                              <li className="statute-ref">
                                Defines a condominium as a form of ownership
                                where unit owners own individual units and share
                                ownership of common areas.
                              </li>
                            </ul>
                          </li>
                          <li className="florida-act-list">
                            <div className="definition">
                              Declaration of a Condominium
                            </div>
                            <div className="comp-summary mt-2 mb-2">
                              Statute: 718.104(2)
                            </div>
                            <ul className="laws-sublist">
                              <li className="statute-ref">
                                A condominium is created by recording a
                                declaration that includes the condominium's
                                legal description , governance structure, and
                                restrictions.
                              </li>
                            </ul>
                          </li>
                          <li className="florida-act-list">
                            <div className="definition">
                              Voting Rights of Unit Owners
                            </div>
                            <div className="comp-summary mt-2 mb-2">
                              Statute: 718.106(1)(a)
                            </div>
                            <ul className="laws-sublist">
                              <li className="statute-ref">
                                Each unit has a vote in the affairs of the
                                association unless otherwise provided in the
                                declaration.
                              </li>
                            </ul>
                          </li>
                          <li className="florida-act-list">
                            <div className="definition">
                              Financial Reporting Requirements
                            </div>
                            <div className="comp-summary mt-2 mb-2">
                              Statute: 718.111(13)
                            </div>
                            <ul className="laws-sublist">
                              <li className="statute-ref">
                                Associations must prepare and distribute annual
                                financial reports, such as compilation, review,
                                or audit, based on annual revenue.
                              </li>
                            </ul>
                          </li>
                          <li className="florida-act-list">
                            <div className="definition">
                              Board of Directors' Fiduciary Duty
                            </div>
                            <div className="comp-summary mt-2 mb-2">
                              Statute: 718.111(a)
                            </div>
                            <ul className="laws-sublist">
                              <li className="statute-ref">
                                Board members must act in good faith, in the
                                best interests of the association, and with due
                                care.
                              </li>
                            </ul>
                          </li>
                        </ol>
                      </div>
                      <div className="state-laws-box" ref={newYorkRef}>
                        <h6 className="laws-title mt-2">
                          New York's Chapter 718 Condominium Act
                        </h6>
                        <ol className="ps-0">
                          <li className="florida-act-list">
                            <div className="definition">
                              Definition of a Condominium
                            </div>
                            <div className="comp-summary mt-2 mb-2">
                              Statute: 718.103(11)
                            </div>
                            <ul className="laws-sublist">
                              <li className="statute-ref">
                                Defines a condominium as a form of ownership
                                where unit owners own individual units and share
                                ownership of common areas.
                              </li>
                            </ul>
                          </li>
                          <li className="florida-act-list">
                            <div className="definition">
                              Declaration of a Condominium
                            </div>
                            <div className="comp-summary mt-2 mb-2">
                              Statute: 718.104(2)
                            </div>
                            <ul className="laws-sublist">
                              <li className="statute-ref">
                                A condominium is created by recording a
                                declaration that includes the condominium's
                                legal description , governance structure, and
                                restrictions.
                              </li>
                            </ul>
                          </li>
                          <li className="florida-act-list">
                            <div className="definition">
                              Voting Rights of Unit Owners
                            </div>
                            <div className="comp-summary mt-2 mb-2">
                              Statute: 718.106(1)(a)
                            </div>
                            <ul className="laws-sublist">
                              <li className="statute-ref">
                                Each unit has a vote in the affairs of the
                                association unless otherwise provided in the
                                declaration.
                              </li>
                            </ul>
                          </li>
                          <li className="florida-act-list">
                            <div className="definition">
                              Financial Reporting Requirements
                            </div>
                            <div className="comp-summary mt-2 mb-2">
                              Statute: 718.111(13)
                            </div>
                            <ul className="laws-sublist">
                              <li className="statute-ref">
                                Associations must prepare and distribute annual
                                financial reports, such as compilation, review,
                                or audit, based on annual revenue.
                              </li>
                            </ul>
                          </li>
                          <li className="florida-act-list">
                            <div className="definition">
                              Board of Directors' Fiduciary Duty
                            </div>
                            <div className="comp-summary mt-2 mb-2">
                              Statute: 718.111(a)
                            </div>
                            <ul className="laws-sublist">
                              <li className="statute-ref">
                                Board members must act in good faith, in the
                                best interests of the association, and with due
                                care.
                              </li>
                            </ul>
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <AllChatbot />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Laws;
